import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, TransitionGroup as _TransitionGroup, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withId = /*#__PURE__*/_withScopeId("data-v-b50ef614");

_pushScopeId("data-v-b50ef614");

var _hoisted_1 = {
  key: 0,
  class: "no-redirect"
};

_popScopeId();

export var render = /*#__PURE__*/_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

  var _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

  return _openBlock(), _createBlock(_component_el_breadcrumb, {
    class: "app-breadcrumb",
    separator: "/"
  }, {
    default: _withId(function () {
      return [_createVNode(_TransitionGroup, {
        name: "breadcrumb"
      }, {
        default: _withId(function () {
          return [(_openBlock(true), _createBlock(_Fragment, null, _renderList($data.levelList, function (item, index) {
            return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
              key: item.path
            }, {
              default: _withId(function () {
                return [item.redirect === 'noRedirect' || index == $data.levelList.length - 1 ? (_openBlock(), _createBlock("span", _hoisted_1, _toDisplayString(item.meta.title), 1
                /* TEXT */
                )) : (_openBlock(), _createBlock("a", {
                  key: 1,
                  onClick: _withModifiers(function ($event) {
                    return $options.handleLink(item);
                  }, ["prevent"])
                }, _toDisplayString(item.meta.title), 9
                /* TEXT, PROPS */
                , ["onClick"]))];
              }),
              _: 2
              /* DYNAMIC */

            }, 1024
            /* DYNAMIC_SLOTS */
            );
          }), 128
          /* KEYED_FRAGMENT */
          ))];
        }),
        _: 1
        /* STABLE */

      })];
    }),
    _: 1
    /* STABLE */

  });
});